import { handleAPIError } from "@services/Base";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { MODEL_API_URL } from "../../../config";
import { ClientModel, ClientModelCreate } from "../types";

export const useSaveClientModel = () => {
  return useMutation({
    mutationFn: (props: ClientModelCreate) => {
      const formData = new FormData();
      formData.append("input_file", props.input_file);
      formData.append("output_file", props.output_file);
      formData.append("params_file", props.parameters_file);
      if (props.baseline_organic_file) {
        formData.append("baseline_organic_file", props.baseline_organic_file);
      }
      const modelNameEncoded = encodeURIComponent(props.name);
      return axios
        .post(
          `${MODEL_API_URL}/waves-model-manager-api/v1/models/clients/${props.client_id}?name=${modelNameEncoded}&year=${props.year}&aggregation_type=${props.aggregation_type}`,
          formData
        )
        .then((response) => {
          return response.data as ClientModel;
        })
        .catch((error) => {
          return handleAPIError(error);
        });
    }
  });
};
